import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { InfoTooltipIcon } from '../../Feedback/InfoTooltipIcon';
export const StyledLabel = styled.label `
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ disabled, theme }) => (disabled ? theme.colors.grey70_1 : theme.colors.grey100_1)};
  margin-bottom: ${({ $noMargin }) => ($noMargin ? '0px' : '4px')};
  gap: 4px;
`;
const RequiredSpan = styled.span `
  color: ${({ theme, disabled }) => (disabled ? theme.colors.critical30 : theme.colors.critical100)};

  &::before {
    padding-left: 2px;
    content: '*';
  }
`;
const combineTestIds = (element, root) => (root ? `${root}-${element}` : undefined);
const Label = ({ children, required, tooltip, disabled, noMargin, className, dataTestId, as }) => {
    const getDataTestId = useCallbackRef((elementId) => combineTestIds(elementId, dataTestId));
    return (_jsxs(StyledLabel, { as: as, disabled: disabled, "$noMargin": noMargin, className: className, "data-testid": dataTestId, children: [_jsxs("span", { children: [children, required ? _jsx(RequiredSpan, { "data-testid": getDataTestId('required-indicator'), disabled: disabled }) : ''] }), tooltip ? _jsx(InfoTooltipIcon, { tooltip: tooltip, dataTestIdIcon: getDataTestId('info-icon') }) : ''] }));
};
export default Label;
